import React, { Component } from 'react';
class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: 'React'
        };
    }

    shouldComponentUpdate() {
        return false;
    }


    render() {
        return (
            <p className="footer-content">
                {this.props.t("copyright")}<strong>{this.props.t("poweredby")}</strong> {this.props.t("rights.reserved")}
                <span className="version-txt">{this.props.config.version} </span>
            </p>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/app/layout/Footer.js